<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="标题：">
            <el-input
              v-model="query.title"
              placeholder="请输入标题"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="分类：">
            <el-cascader
              v-model="categorizeIdArr"
              :options="categorizeOptions"
              :props="{
                checkStrictly: true,
                label: 'name',
                value: 'id',
                children: 'childList'
              }"
              clearable
              size="small"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select
              v-model="query.state"
              placeholder="请选择"
              clearable
              size="small"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间：">
            <el-date-picker
              v-model="createdTimeRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button
            type="primary"
            size="mini"
            @click="handleCreate"
            icon="el-icon-plus"
            >新增</el-button
          >
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="list"
        @selection-change="selectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="50" />
        <!-- <el-table-column label="id" prop="id" align="center" /> -->
        <el-table-column label="标题" align="center" width="200" fixed="left">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="handleShow(row, 2)">
              {{ row.templateMaterialsSharePO && row.templateMaterialsSharePO.title }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="分类 " align="center" width="140px">
          <template slot-scope="{ row }">
            {{ row.templateClassification && row.templateClassification.name }}
          </template>
        </el-table-column>
        <el-table-column label="封面图" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="
                row.templateMaterialsSharePO &&
                  row.templateMaterialsSharePO.coverImage
              "
              style="width: 50px; height: 50px"
              :src="row.templateMaterialsSharePO.coverImage"
              :preview-src-list="[row.templateMaterialsSharePO.coverImage]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="会议" align="center" width="140px">
          <template slot-scope="{ row }">
            {{ row.meeting && row.meeting.title }}
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" width="100px">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.templateMaterialsSharePO.state"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(row)"
            ></el-switch
            >{{
              row.templateMaterialsSharePO && row.templateMaterialsSharePO.state
                ? "启用"
                : "禁用"
            }}
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.orderNo
            }}
          </template>
        </el-table-column>
        <el-table-column label="浏览量" align="center">
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.abrowseNum
            }}
          </template>
        </el-table-column>
        <el-table-column label="点赞量" align="center">
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.alikeNum
            }}
          </template>
        </el-table-column>
        <el-table-column label="转发量" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="handleShow(row, 3)">{{
              row.templateMaterialsSharePO &&
                (row.templateMaterialsSharePO.aforwardNum || 0)
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="发布时间"
          sortable="custom"
          align="center"
          width="200"
        >
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.createdTime
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          sortable="custom"
          align="center"
          width="200"
        >
          <template slot-scope="{ row }">
            {{
              row.templateMaterialsSharePO &&
                row.templateMaterialsSharePO.operatedTime
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center">
          <template slot-scope="{ row }">
            {{ row.operatedUserPO && row.operatedUserPO.realName }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)"
              >删除</el-button
            >
            <el-button type="text" @click="handleLog(row)">日志管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <!-- 新建表单 -->
    <classify-add
      ref="classifyAdd"
      @created="doQueryList({})"
      :categorizeOptions="JSON.parse(JSON.stringify(categorizeOptions))"
    />
  </div>
</template>

<script>
import classifyAdd from "./add";
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
import Pagination from "@/components/Pagination";
import templateClassificationApi from "@/api/marketing/templateClassification";
export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNoSortSign: 1
      },
      selectItems: [],
      categorizeOptions: [],
      categorizeIdArr: [],
      createdTimeRange: null
    };
  },
  created() {
    this.doQueryList({ pageNo: 1 });
    this.getSelectOptions();
  },
  methods: {
    // 标题字段为后端存储的 JSON 字符串，这里解析并拼装展示
    formatTitle(title) {
      if (!title) return "--";
      try {
        const list = typeof title === "string" ? JSON.parse(title) : title;
        if (!Array.isArray(list)) return "--";
        const names = list
          .map(it => it && (it.titleName || it.name || ""))
          .filter(Boolean);
        return names.length ? names.join(" / ") : "--";
      } catch (e) {
        return title || "--";
      }
    },
    getSelectOptions() {
      templateClassificationApi
        .fetchTreeList({ pageNo: 1, pageSize: 1000, state: 1, sourceType: 1 })
        .then(({ data }) => {
          this.categorizeOptions = this.formatCascaderData(data.list);
        });
    },
    formatCascaderData(data) {
      if (!Array.isArray(data)) return data;
      // 深拷贝处理，避免修改原始数据
      return data.map(item => {
        const formattedItem = { ...item };
        if (
          !formattedItem.childList ||
          !Array.isArray(formattedItem.childList) ||
          formattedItem.childList.length < 1
        ) {
          // children若为空数组或不存在，则将children设为undefined
          formattedItem.childList = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          formattedItem.childList = this.formatCascaderData(
            formattedItem.childList
          );
        }
        return formattedItem;
      });
    },
    handleShow(row, type) {
      // 确保传递包含 id 的对象，id 从 templateMaterialsSharePO 中提取
      const id =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.id;
      const rowData = { ...row, id };
      this.$emit("handleShow", rowData, type);
    },
    handleFilter() {
      this.categorizeIdArr = [];
      this.query = {};
      this.createdTimeRange = null;
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign",
        operatedTime: "operatedTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      this.query.sourceType = 1;
      // 处理发布时间范围
      if (this.createdTimeRange && this.createdTimeRange.length === 2) {
        this.query.createdTimeStart = this.createdTimeRange[0];
        this.query.createdTimeEnd = this.createdTimeRange[1];
      } else {
        this.query.createdTimeStart = undefined;
        this.query.createdTimeEnd = undefined;
      }
      this.query.classificationId =
        this.categorizeIdArr.length > 0
          ? this.categorizeIdArr[this.categorizeIdArr.length - 1]
          : undefined;
      this.listLoading = true;
      return templateMaterialsShareApi
        .fetchList(this.query)
        .then(data => {
          this.list = data.data.list;
          this.total = data.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      const id =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.id;
      if (!id) return;
      return this.$common
        .confirm("是否确认删除")
        .then(() => templateMaterialsShareApi.deleteById({ ids: id }))
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      return this.$common
        .confirm("是否确认删除")
        .then(() =>
          templateMaterialsShareApi.deleteBatch({
            ids: this.selectItems
              .map(
                row =>
                  row.templateMaterialsSharePO &&
                  row.templateMaterialsSharePO.id
              )
              .filter(Boolean)
          })
        )
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command
      };
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择分类");
        return;
      }
      const ids = this.selectItems
        .map(
          row => row.templateMaterialsSharePO && row.templateMaterialsSharePO.id
        )
        .filter(Boolean);
      if (command.command === 1) {
        this.handleBatchState(ids, 1);
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0);
      }
    },
    handleBatchState(ids, type) {
      const txt =
        type === 1 ? "确认将选中分类批量启用？" : "确认将选中分类批量禁用？";
      this.$common
        .confirm(txt)
        .then(() =>
          templateMaterialsShareApi.setIsEnableBatch({
            ids: ids,
            isEnable: type === 1
          })
        )
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    changeSwitch(row) {
      const id =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.id;
      const state =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.state;
      if (!id) return;
      templateMaterialsShareApi
        .setIsEnable({ ids: id, state: state })
        .then(() => {
          this.$common.showMsg("success", "操作成功");
        });
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row);
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      // 确保传递包含 id 的对象，id 从 templateMaterialsSharePO 中提取
      const id =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.id;
      const rowData = { ...row, id };
      this.$refs.classifyAdd.handleUpdate(rowData);
    },
    handleLog(row) {
      const id =
        row.templateMaterialsSharePO && row.templateMaterialsSharePO.id;
      if (!id) return;
      this.$router.push("/log/log?type=122&id=" + id);
    }
  }
};
</script>
